module.exports = __webpack_public_path__ + "static/media/payment-bank-info-cvv.ce727f9c.svg";